import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// only for web
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

// only for web
posthog.init(environment.posthogKey, {
  api_host: environment.posthogHost,
  ui_host: 'https://us.posthog.com',
  defaults: '2026-05-30',
  person_profiles: 'identified_only'
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
